import {PolicyLapse as PolicyLapseLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';
import {toMoneyValue} from 'Shared/utilities/FormatMoney';

type PolicyLapseProps = {
  policyLapseLetter: PolicyLapseLetter;
};

const PolicyLapse = (props: PolicyLapseProps) => {
  return (
    <>
      <CardField name="Date" value={toFormattedDateAsUTC(props.policyLapseLetter.date)} />
      <CardField name="Coverage Case Date" value={toFormattedDateAsUTC(props.policyLapseLetter.coverageCeaseDate)} />
      <CardField name="Coverage Type" value={props.policyLapseLetter.coverageType} />
      <CardField name="Reinstatement Amount Due" value={toMoneyValue(props.policyLapseLetter.reinstatementAmountDue)} />
      <CardField name="Agent Number" value={props.policyLapseLetter.agentNumber} />
      <CardField name="Insured Name" value={props.policyLapseLetter.insuredName} />
      <CardField name="Owner Name" value={props.policyLapseLetter.ownerName} />
      <CardField name="Owner Address" value={props.policyLapseLetter.ownerAddress!.fullAddress} />
      <CardField name="Policy Number" value={props.policyLapseLetter.policyNumber} />
    </>
  );
};

export default PolicyLapse;
